const CLASS_BY_VARIATION = {
  original: 'slide',
  material: 'slide-material',
};

module.exports = { CLASS_BY_VARIATION };
